import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { ChatMessage as ChatMessageType } from '../types';
import { ChartWidget } from './ChartWidget';

interface ChatMessageProps {
  message: ChatMessageType;
}

export const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user';

  return (
    <div className={`chat-message ${isUser ? 'user' : 'assistant'}`}>
      <div className="message-avatar">
        {isUser ? (
          <div className="avatar user-avatar">U</div>
        ) : (
          <div className="avatar assistant-avatar">AI</div>
        )}
      </div>
      <div className="message-content">
        {message.reasoningContent && (
          <div className="reasoning-content">
            <div className="reasoning-label">思考过程</div>
            <ReactMarkdown remarkPlugins={[remarkGfm]} className="reasoning-text">
              {message.reasoningContent}
            </ReactMarkdown>
          </div>
        )}
        {/* 渲染图表 */}
        {message.charts && message.charts.length > 0 && (
          <div className="message-charts">
            {message.charts.map((chart, index) => (
              <ChartWidget key={`${chart.title}-${index}`} chart={chart} />
            ))}
          </div>
        )}
        <div className="message-text">
          {isUser ? (
            <p>{message.content}</p>
          ) : (
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
              {message.content}
            </ReactMarkdown>
          )}
          {message.isStreaming && (
            <span className="streaming-cursor">▊</span>
          )}
        </div>
      </div>
    </div>
  );
};
